import Config from "../config";

class WishListService {
    constructor () {
        this.config = new Config();
        this.prodLevId = undefined;
    }

    toggleWishList (btnHeart) {
        let inList = btnHeart.hasClass('is-active');
        let method = inList ? 'DELETE' : 'POST';
        let title = !inList ? 'Verwijder product van de favorietenlijst' : 'Voeg product toe aan de favorietenlijst!';

        this.prodLevId = btnHeart.data('prodlevid');

        return $.ajax({
            url: `${this.config.getDomain()}/dashboard/wishlist`,
            type: method,
            data: JSON.stringify({
                productId: this.prodLevId,
            }),
            contentType: 'application/json',
            dataType: 'json'
        }).done(response => {
            if (response.result) {
                btnHeart.attr('title', title);
                btnHeart.toggleClass('is-active');
            }
        }).fail(error => {
            console.error('Error:', error);
        });
    }
}

export default WishListService;
